import { HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BasketModel,
  Order,
  OrderCreationModel,
  OrderCreationResult,
  QuotationResult,
} from '@core/hera-models';
import { Observable } from 'rxjs';
import { ApiService } from '@core/api';

@Injectable({
  providedIn: 'root',
})
export class OrderDataService {
  constructor(private apiService: ApiService) {}

  postOrder(
    body: OrderCreationModel,
    captchaToken: string
  ): Observable<HttpResponse<OrderCreationResult>> {
    return this.apiService.postV2(
      'orders',
      body,
      new HttpHeaders()
        .set('captcha-response', captchaToken)
        .set('Content-Type', 'application/json'),
      new HttpParams(),
      'response'
    );
  }

  fetchOrder(orderId: string): Observable<Order> {
    return this.apiService.getV2(`orders/${orderId}`);
  }

  // TODO: handle mocks with proxy
  postQuotation(
    body: BasketModel,
    captchaToken: string
  ): Observable<HttpResponse<QuotationResult>> {
    return this.apiService.postV2(
      'orders/quotation',
      body,
      new HttpHeaders()
        .set('captcha-response', captchaToken)
        .set('Content-Type', 'application/json'),
      new HttpParams(),
      'response'
    );
  }
}
